export enum ROUTE_URLS {
  HOME = "/company",
  LOGIN = "/login",
}
